/**
 * 관리자 서비스
 */

import apiClient from './api';
import {
  AdminUser,
  AdminUserFilter,
  AdminUserListResponse,
  AdminUserCreateRequest,
  AdminUserUpdateRequest,
} from '../types/admin';

export const adminService = {
  /**
   * 관리자 목록 조회
   */
  async getAdmins(filter: AdminUserFilter = {}): Promise<AdminUserListResponse> {
    const params = new URLSearchParams();

    if (filter.status) params.append('status', filter.status);
    if (filter.role) params.append('role', filter.role);
    if (filter.search) params.append('search', filter.search);
    if (filter.page) params.append('page', filter.page.toString());
    if (filter.limit) params.append('limit', filter.limit.toString());

    const response = await apiClient.get(`/admin/admins?${params.toString()}`);
    const backendData = response.data.data;

    // 백엔드 응답 형식을 프론트엔드 타입에 맞게 변환
    return {
      admins: backendData.admins || [],
      pagination: {
        current_page: backendData.page || 1,
        total_pages: backendData.total_pages || 1,
        total_count: backendData.total || 0,
        limit: backendData.limit || 20,
      },
    };
  },

  /**
   * 관리자 상세 조회
   */
  async getAdmin(id: number): Promise<AdminUser> {
    const response = await apiClient.get(`/admin/admins/${id}`);
    return response.data.data.admin;
  },

  /**
   * 관리자 등록
   */
  async createAdmin(data: AdminUserCreateRequest): Promise<AdminUser> {
    const response = await apiClient.post('/admin/admins', data);
    return response.data.data.admin;
  },

  /**
   * 관리자 수정
   */
  async updateAdmin(id: number, data: AdminUserUpdateRequest): Promise<AdminUser> {
    const response = await apiClient.put(`/admin/admins/${id}`, data);
    return response.data.data.admin;
  },

  /**
   * 관리자 삭제
   */
  async deleteAdmin(id: number): Promise<void> {
    await apiClient.delete(`/admin/admins/${id}`);
  },

  /**
   * 관리자 비밀번호 변경
   */
  async changePassword(id: number, newPassword: string): Promise<void> {
    await apiClient.post(`/admin/admins/${id}/change-password`, { password: newPassword });
  },
};

